import { render, staticRenderFns } from "./metadata-gdpr.vue?vue&type=template&id=7e12f4b8&scoped=true&"
import script from "./metadata-gdpr.vue?vue&type=script&lang=js&"
export * from "./metadata-gdpr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e12f4b8",
  null
  
)

export default component.exports